module.exports = __webpack_public_path__ + "media/images/favicon-e32820c6.ico";